import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {saveParameterToJson, loadParameterFromJson} from 'parameters/parameterJsonFunctions.js';
import Sample from 'repos/Sample.js';
import {AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import Sampler from 'instruments/Sampler.js';
import ParameterContext from 'effects/ParameterContext.js';
import Tone from 'tone';
import {INSTRUMENT} from 'constants/track-types.js';
import {setFreezeColumnSamples} from 'actions/index.js';

var disposed = 0;
var constructed = 0;
/**
 * Each track can contain mulitple columns, each of which
 * contains several freezes (with at most 1 playing)
 */

class FreezeColumn {

    constructor(sequencerEngine, track, number) {
        this.output = new Tone.Gain(1);
        this.parameters = [];
        this.number = number;

        this.frozenSettings = []; 
        this.frozenSamples = [];
        this.frozenSamplers = [];
        this.sequencerEngine = sequencerEngine;
        this.track = track;
        this.store = sequencerEngine.store;

        // controls which thing is playing
        this.playingParameter = new AbstractParameter(
            'playing', this,
            (o, x) => [],
            {
                isAlwaysLocked: true,
                min: 0,
                max: 32,
                unit: '',
                defaultValue: undefined,
                automatable: true
            });

        this.registerParameter(this.playingParameter);

        this.gainParameter = new AudioParamValueParameter(
            'gain',
            this.output.gain,
            {
                isAlwaysLocked: true,
                min: 0,
                max: 1,
                defaultValue: 1,
            });
        this.registerParameter(this.gainParameter);
    }

    updateRedux() {
        this.store.dispatch(
            setFreezeColumnSamples(
                this.track.id,
                this.number,
                [... this.frozenSamples]));
    }

    registerParameter(param) {
        this.parameters.push(param);
        param.setStore(this.store);
        param.setContext(new ParameterContext().forTrack(this.track));
    }

    set playing(p) {
        this.playingParameter.set(p);
    }

    get playing() {
        let p = this.playingParameter.get();
        if (p !== undefined && p !== null) {
            return Math.round(p);
        }
        return undefined;
    }

    saveAndPlayFrozen(n) {
        this.track.lastFrozenSettings = this.sequencerEngine.getTrackPreset(this.track.trackNumber);
        this.playing = n;
        this.track.clearEffectsAndSamplers();
        this.track.effectsChains[0].initDefault();
        this.track.applyWarp();
        this.track.isFrozen = true;
        this.track.isFrozenPlaying = true;

        if (this.track.getTrackType() === INSTRUMENT) {
            this.track.instrument.dispose();
        }
    }

    loadFrozenSample(sample, tempo=this.sequencerEngine.bpm) {
        this.frozenSamples.push(sample);

        let samplerData = {
            slices: undefined,
            offset: 0,
            transpose: 0,
            volume: 0
        };

        console.log("LOADINNG FORZEN SAMPLER");
        let frozenSampler = 
            new Sampler(
                this.track,
                sample, (s) => {
                    console.log("connecting frozen to output");
                    s.gainNode.connect(this.output);
                }, undefined,
                samplerData);

        frozenSampler.tempo = tempo;
        frozenSampler.init();
        this.output.gain.value = 1;
        this.frozenSamplers.push(frozenSampler);
        this.updateRedux();
        return frozenSampler;
    }

    getJson() {
        let json = {
            frozenSettings: this.frozenSettings,
            frozenSamples: this.frozenSamples.map(x => x.getId()),
            frozenTempos: this.frozenSamplers.map(x => x.tempo),
        };

        json = saveParameterToJson(json, 'playingParameter', this.playingParameter);
        json = saveParameterToJson(json, 'gainParameter', this.gainParameter);
        return json;
    }

    getJsonSync() {
        let json = {
            frozenSettings: this.frozenSettings,
            frozenSamples: this.frozenSamples.map(s => s.getCopy(true)),
            frozenTempos: this.frozenSamplers.map(x => x.tempo),
        };

        for (let s of this.frozenSamplers) {
            s.isCopied = true;
        }
        
        json = saveParameterToJson(json, 'playingParameter', this.playingParameter);
        json = saveParameterToJson(json, 'gainParameter', this.gainParameter);
        return json;
    }

    fromJsonSync(json) {
        this.frozenSettings = json.frozenSettings;

        for (let i in json.frozenSamples) {
            let sample = json.frozenSamples[i];
            let sampler = this.loadFrozenSample(sample, json.frozenTempos[i]);
            sampler.isCopied = true;
        }

        loadParameterFromJson(json, 'playingParameter', this.playingParameter, this.sequencerEngine);
        loadParameterFromJson(json, 'gainParameter', this.gainParameter, this.sequencerEngine);
    }

    async fromJson(json) {
        this.frozenSettings = json.frozenSettings;

        for (let i in json.frozenSamples) {
            let id = json.frozenSamples[i];
            let sample = new Sample(id);
            await sample.load();
            this.loadFrozenSample(sample, json.frozenTempos[i]);
        }

        loadParameterFromJson(json, 'playingParameter', this.playingParameter, this.sequencerEngine);
        // loadParameterFromJson(json, 'gainParameter', this.gainParameter, this.sequencerEngine);
    }

    dispose() {
        disposed += this.frozenSamples.length;
        this.frozenSamplers.forEach(s => s.dispose());
        this.frozenSamples.forEach(s => s.dispose());
        this.frozenSamplers = undefined;
        this.frozenSamples = undefined;
        
        this.output.dispose();
        this.output = undefined;
    }
}

export default FreezeColumn;
